import CommentTableHelper from './comment-table-helper';


const PostHelpers = {
    TableMain: CommentTableHelper
}

export default PostHelpers;